import React, { memo, useContext, useState, useEffect } from "react";
import { Input } from "@mui/material";

import { RetornoLoteContext } from "../../Context/RetornoLoteContext";
import formatoMoeda from "../../../../../utils/formatoMoeda";
import { enqueueSnackbar } from "notistack";

function InputValorRecebido({ row }) {
  const {
    setGlosas,
    setAtualizaValoresRecebimentoManual,
    valorRecuperadoOriginal,
    valorOriginalEnviado,
    valor_recuperado,
  } = useContext(RetornoLoteContext);

  const { id, valor_recebido } = row;
  const [valorRecebido, setValorRecebido] = useState(valor_recebido || 0);

  useEffect(() => {
    if (valor_recebido) {
      setValorRecebido(formatoMoeda(valor_recebido, true));
    }
    // eslint-disable-next-line
  }, [row]);

  function alteraValorRecebido(valor) {
    setGlosas((prevState) => {
      const novoValorRecebido = prevState;
      const resultado = novoValorRecebido.map((item) => {
        if (item.id === id) {
          return { ...item, valor_recebido: valor };
        }
        return { ...item };
      });

      return resultado;
    });
    setAtualizaValoresRecebimentoManual((prevState) => !prevState);
  }

  function handleBlur(event) {
    const valorDigitado = event.target.value.trim();

    if (valorDigitado === "" || valorDigitado === null) {
      alteraValorRecebido(0);
      setValorRecebido("");
      return;
    }

    const valorLimpo = valorDigitado.replace(/\./g, "").replace(",", ".");
    const valorNumerico = parseFloat(valorLimpo);

    if (!isNaN(valorNumerico) && isFinite(valorNumerico)) {
      alteraValorRecebido(valorNumerico);
      setValorRecebido(formatoMoeda(valorNumerico, true));
    } else {
      enqueueSnackbar("Valor inválido", { variant: "warning" });
      if (valor_recebido) {
        setValorRecebido(formatoMoeda(valor_recebido, true));
      } else {
        setValorRecebido("");
      }
    }
  }

  return (
    <>
      <Input
        id="valor_recebido"
        value={valorRecebido}
        onChange={(event) => setValorRecebido(event.target.value)}
        sx={{
          "& .MuiInputBase-input": {
            padding: "6px 4px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }}
        onBlur={(event) => handleBlur(event)}
      />
    </>
  );
}

export default memo(InputValorRecebido);
